module.exports = __webpack_public_path__ + "static/img/email_sent.e1c7240.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/frontend/email_sent.gif
// module id = dl5I
// module chunks = 134